/**
 * The mandate data an EXTF file needs in its header. Beraternummer and Mandantennummer come from
 * the tax advisor — without them DATEV rejects the import, so they are asked for rather than
 * guessed, and the EXTF export stays blocked until they are set.
 *
 * Die WERTE stehen in der Grundkonfiguration des Mandanten (company_profiles.profile); diese Datei
 * haelt nur noch die Form und die Pruefungen. Bis 09/2026 lagen sie zusaetzlich im localStorage --
 * damit exportierte jedes Geraet mit eigenen Angaben. Abbildung: apps/web/src/finance/companySettings.ts.
 */
export interface DatevSettings {
  readonly consultantNumber: string;
  readonly clientNumber: string;
  /** First day of the Wirtschaftsjahr, YYYY-MM-DD. */
  readonly fiscalYearStart: string;
  /** Sachkonten length; Personenkonten are one digit longer. */
  readonly accountLength: number;
}

export const emptyDatevSettings: DatevSettings = {
  consultantNumber: '',
  clientNumber: '',
  fiscalYearStart: '',
  accountLength: 4,
};


function isDigits(value: string, maxLength: number): boolean {
  return /^\d+$/.test(value) && value.length <= maxLength;
}

/** All four fields present and plausible — the gate in front of the EXTF export. */
export function isDatevConfigured(settings: DatevSettings): boolean {
  return isDigits(settings.consultantNumber, 7)
    && isDigits(settings.clientNumber, 5)
    && /^\d{4}-\d{2}-\d{2}$/.test(settings.fiscalYearStart)
    && [4, 5, 6, 7, 8].includes(settings.accountLength);
}

/** What is still missing, in the words the user needs to act on. */
export function datevSettingsIssues(settings: DatevSettings): readonly string[] {
  const issues: string[] = [];
  if (!isDigits(settings.consultantNumber, 7)) issues.push('Beraternummer fehlt (Ziffern, vom Steuerberater).');
  if (!isDigits(settings.clientNumber, 5)) issues.push('Mandantennummer fehlt (Ziffern, vom Steuerberater).');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(settings.fiscalYearStart)) issues.push('Beginn des Wirtschaftsjahres fehlt.');
  return issues;
}

